import { darkTheme, RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { wagmiConfig } from '@shared/configs/wagmi-config';
import { INITIAL_CHAIN } from '@shared/constants/chains';
import { CurrenciesProvider, SELECTED_REGION_STORAGE_KEY } from '@shared/contexts/currencies-context';
import { GeolocationProvider } from '@shared/contexts/geolocation';
import { ModalProvider } from '@shared/contexts/modal-context';
import { OffersProvider } from '@shared/contexts/offers';
import { UserInfoProvider } from '@shared/contexts/user-info';
import { WalletsProvider } from '@shared/contexts/wallets-context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FC, useMemo } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { WagmiProvider } from 'wagmi';
import { RouterPathes } from '../constants/router-paths';
import { AppLayout } from '../layouts/app-layout';
import { Home } from '../pages/HomePage';
import { OfferCheckout } from '../pages/OfferCheckoutPage';

const queryClient = new QueryClient();

const App: FC = () => {
  const checkoutRoutes = useMemo(
    () => [RouterPathes.offerCheckout, RouterPathes.checkoutSuccess].map((path) => (
      <Route
        key={path}
        path={path}
        element={<OfferCheckout />}
      />
    )),
    [],
  );

  return (
    <>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider
            initialChain={INITIAL_CHAIN}
            theme={darkTheme({
              borderRadius: 'small',
              overlayBlur: 'small',
            })}
          >
            <UserInfoProvider>
              <WalletsProvider>
                <ModalProvider>
                  <BrowserRouter>
                    <GeolocationProvider enabled={!localStorage.getItem(SELECTED_REGION_STORAGE_KEY)}>
                      <CurrenciesProvider>
                        <OffersProvider>

                          <Routes>
                            <Route element={<AppLayout />}>
                              <Route
                                path={RouterPathes.home}
                                element={<Home />}
                              />
                              {checkoutRoutes}
                            </Route>
                          </Routes>

                        </OffersProvider>
                      </CurrenciesProvider>
                    </GeolocationProvider>
                  </BrowserRouter>
                </ModalProvider>
              </WalletsProvider>
            </UserInfoProvider>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
      <ToastContainer
        position="top-right"
        theme="dark"
        hideProgressBar
        style={{
          top: '40px',
          zIndex: '100',
        }}
      />
    </>
  );
};

export default App;
